import { botClient, makeServicePlugin, BaseModel } from '@/bot'

class GeofenceGroups extends BaseModel {
  constructor(data, options) {
    super(data, options)
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'GeofenceGroups'
  // Define default properties here
  static instanceDefaults() {
    return {
      geofence_id: null,
      group_id: null
    }
  }
}

const servicePath = 'geofence-groups'
const servicePlugin = makeServicePlugin({
  Model: GeofenceGroups,
  service: botClient.service(servicePath),
  servicePath
})

// Setup the client-side Feathers hooks.
botClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin